console.log('[EFS VERSION] 2026-03-25-3');

window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function(){ dataLayer.push(arguments); };

window.EFS_TRACK = window.EFS_TRACK || {};

(function () {
  var FORM_SEND_TO = 'AW-17590363336/0uTACJHbhY8cEMjJ3sNB';
  var CHAT_SEND_TO = 'AW-17590363336/IJksCO3h-44cEMjJ3sNB';

  function normalizeEmail(email) {
    if (!email) return '';
    return String(email).trim().toLowerCase();
  }

  function normalizePhone(phone) {
    if (!phone) return '';
    var p = String(phone).trim().replace(/[^\d+]/g, '');

    if (/^\d{10}$/.test(p)) {
      p = '+1' + p;
    } else if (/^1\d{10}$/.test(p)) {
      p = '+' + p;
    } else if (/^\d{11,15}$/.test(p) && p.charAt(0) !== '+') {
      p = '+' + p;
    }

    return p;
  }

  function buildUserData(extra) {
    extra = extra || {};

    var email = normalizeEmail(extra.email || extra.mail || extra.email_address);
    var phone = normalizePhone(extra.phone || extra.tel || extra.mobile || extra.phone_number);

    var userData = {};
    if (email) userData.email = email;
    if (phone) userData.phone_number = phone;

    return Object.keys(userData).length ? userData : null;
  }

  function sendLead(eventName, leadType, method, sendTo, extra) {
    extra = extra || {};

    var payload = {
      lead_type: leadType,
      method: method,
      page_location: window.location.href,
      page_path: window.location.pathname,
      debug_mode: true
    };

    for (var k in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, k)) {
        payload[k] = extra[k];
      }
    }

    var userData = buildUserData(extra);
    if (userData) {
      window.gtag('set', 'user_data', userData);
      console.log('[EFS] user_data set', userData);
    }

    window.gtag('event', eventName, payload);
    console.log('[EFS] GA4 event sent:', eventName, payload);

    window.gtag('event', 'conversion', {
      send_to: sendTo
    });
    console.log('[EFS] Ads conversion sent:', sendTo);
  }

  window.EFS_TRACK.formLead = function (extra) {
    sendLead('contact_form_lead', 'contact_form', 'shopify_contact_form', FORM_SEND_TO, extra);
  };

  window.EFS_TRACK.chatLead = function (extra) {
    sendLead('chat_lead', 'chat', 'tawk_to', CHAT_SEND_TO, extra);
  };
})();

(function () {
  var path = window.location.pathname;
console.log('[EFS] pathname =', path);

// 只要页面上存在 ContactForm，就允许表单追踪逻辑运行
var hasContactForm =
  document.querySelector('#ContactForm') ||
  document.querySelector('#ContactForm-email') ||
  document.querySelector('form[action*="/contact"]');

if (!hasContactForm) {
  return;
}

console.log('[EFS] Contact script loaded on', path);

  var firedKey = 'efs_contact_form_sent';
  var formDataKey = 'efs_contact_form_data';

  function readStoredFormData() {
    try {
      return JSON.parse(sessionStorage.getItem(formDataKey) || '{}');
    } catch (e) {
      return {};
    }
  }

  function writeStoredFormData(data) {
    var current = readStoredFormData();
    var merged = {};

    for (var k in current) {
      if (Object.prototype.hasOwnProperty.call(current, k)) {
        merged[k] = current[k];
      }
    }

    for (var j in data) {
      if (Object.prototype.hasOwnProperty.call(data, j)) {
        merged[j] = data[j];
      }
    }

    sessionStorage.setItem(formDataKey, JSON.stringify(merged));
    console.log('[EFS] Form data saved', merged);
  }

  function getFieldValue(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el.value || '';
    }
    return '';
  }

  function captureCurrentFields() {
    var email = getFieldValue([
      '#ContactForm-email',
      'input[type="email"]',
      'input[name*="email" i]',
      'input[id*="email" i]'
    ]);

    var phone = getFieldValue([
      '#ContactForm-phone',
      'input[type="tel"]',
      'input[name*="phone" i]',
      'input[id*="phone" i]',
      'input[name*="mobile" i]',
      'input[id*="mobile" i]'
    ]);

    var name = getFieldValue([
      '#ContactForm-name',
      'input[name*="name" i]',
      'input[id*="name" i]'
    ]);

    writeStoredFormData({
      email: email,
      phone: phone,
      name: name
    });
  }

  function hasSuccessState() {
    var isSuccess = false;

    if (window.location.href.indexOf('contact_posted=true') > -1) isSuccess = true;
    if (window.location.href.indexOf('#ContactForm') > -1) isSuccess = true;
    if (window.location.href.indexOf('#contact_form') > -1) isSuccess = true;

    var bodyText = (document.body && document.body.innerText ? document.body.innerText : '').toLowerCase();
    if (bodyText.indexOf('thanks for contacting us') > -1) isSuccess = true;
    if (bodyText.indexOf('thank you for contacting us') > -1) isSuccess = true;
    if (bodyText.indexOf('your message has been sent') > -1) isSuccess = true;

    console.log('[EFS] hasSuccessState =', isSuccess, 'url=', window.location.href);
    return isSuccess;
  }

  function fireFormOnce() {
    if (sessionStorage.getItem(firedKey) === '1') {
      console.log('[EFS] form conversion already fired in this session');
      return;
    }

    sessionStorage.setItem(firedKey, '1');

    var stored = readStoredFormData();
    stored.trigger_event = 'contact_form_success';

    if (window.EFS_TRACK && typeof window.EFS_TRACK.formLead === 'function') {
      window.EFS_TRACK.formLead(stored);
      console.log('[EFS] Contact form conversion sent');
    } else {
      console.warn('[EFS] formLead function missing');
    }
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t) return;

    if (
      t.matches('#ContactForm-email') ||
      t.matches('input[type="email"]') ||
      t.matches('input[name*="email" i]') ||
      t.matches('input[id*="email" i]') ||
      t.matches('#ContactForm-phone') ||
      t.matches('input[type="tel"]') ||
      t.matches('input[name*="phone" i]') ||
      t.matches('input[id*="phone" i]') ||
      t.matches('input[name*="mobile" i]') ||
      t.matches('input[id*="mobile" i]') ||
      t.matches('#ContactForm-name') ||
      t.matches('input[name*="name" i]') ||
      t.matches('input[id*="name" i]')
    ) {
      captureCurrentFields();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t) return;

    var btn = t.closest('button[type="submit"], input[type="submit"]');
    if (btn) {
      sessionStorage.removeItem(firedKey);
      captureCurrentFields();
      console.log('[EFS] submit click detected, firedKey cleared');
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form) return;

    if (
      form.matches('form[action*="/contact"]') ||
      form.matches('form.contact-form') ||
      form.matches('.contact form')
    ) {
      sessionStorage.removeItem(firedKey);
      captureCurrentFields();
      console.log('[EFS] form submit detected, firedKey cleared');
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    var success = hasSuccessState();

    if (!success) {
      sessionStorage.removeItem(firedKey);
      console.log('[EFS] not success page, firedKey reset');
    }

    if (success) {
      fireFormOnce();
    }
  });
})();

(function () {
  console.log('[EFS] Chat script ready');

  var chatFiredKey = 'efs_chat_sent';

  function fireChatOnce(extra) {
    if (sessionStorage.getItem(chatFiredKey) === '1') return;
    sessionStorage.setItem(chatFiredKey, '1');

    if (window.EFS_TRACK && typeof window.EFS_TRACK.chatLead === 'function') {
      window.EFS_TRACK.chatLead(extra || {});
      console.log('[EFS] Tawk chat conversion sent');
    }
  }

  function pick(obj, keys) {
    if (!obj) return '';
    for (var i = 0; i < keys.length; i++) {
      if (obj[keys[i]]) return obj[keys[i]];
    }
    return '';
  }

  window.Tawk_API = window.Tawk_API || {};

  window.Tawk_API.onChatMessageVisitor = function () {
    fireChatOnce({ trigger_event: 'onChatMessageVisitor' });
  };

  window.Tawk_API.onPrechatSubmit = function (data) {
    fireChatOnce({
      trigger_event: 'onPrechatSubmit',
      email: pick(data, ['email', 'mail', 'email_address']),
      phone: pick(data, ['phone', 'tel', 'mobile', 'phone_number']),
      name: pick(data, ['name', 'visitor_name'])
    });
  };

  window.Tawk_API.onOfflineSubmit = function (data) {
    fireChatOnce({
      trigger_event: 'onOfflineSubmit',
      email: pick(data, ['email', 'mail', 'email_address']),
      phone: pick(data, ['phone', 'tel', 'mobile', 'phone_number']),
      name: pick(data, ['name', 'visitor_name'])
    });
  };
})();